import styled, { css } from 'styled-components';

export const FavouritesCounter = styled.div`
  cursor: pointer;
  font-size: 1em;
  line-height: 2;
  align-self: auto;
  color: ${props => (props.isSelectedFavourites ? `${props.theme.colors.white} !important`
    : `${props.theme.colors.lightGray}`)};
    
  ${props => props.color && css`
    color: ${props.theme.colors[props.color]};
  `};
  ::selection{
    background: none;
  }
  
`;

export const FavouritesWrapper = styled.div`
    background-color: ${props => (props.isSelectedFavourites ? `${props.theme.colors.selectedColor}` : `${props.theme.colors.white}`)};
    cursor: pointer;
    height: 1.94em;
    width: 3em;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    position: relative;
    border: 1px solid ${props => props.theme.colors.lightGray};
    border-radius: 2px; 
    font-family: ${props => props.theme.fontSets.narrowMedium};
    font-size:16px;
    line-height:22px;
    ${props => props.theme.mediaQueries.tablet_big_down}{
      height: 1.84em;
    }

`;
